<template>
    <div class="comentarios" v-loading="loading">
        <el-timeline id="list-comment">

            <el-timeline-item :key="index" :reverse="false" :timestamp="coment.time" placement="top" v-for="(coment,index) in comments">
                <el-card>
                    <h4>{{coment.text}}</h4>
                    <p>{{`Enviado por  ${coment.user} el ${coment.time}`}}</p>
                </el-card>
            </el-timeline-item>
                
        </el-timeline>

        <div class="send">
            <el-input
            type="textarea"
            placeholder="Escribe un comentario aquí"
            v-model="comment"
            maxlength="200"
            :rows="2"
            show-word-limit
            @keypress.enter.native="sendComment()"
            >
            </el-input>
        </div>
    </div>
</template>

<script>
    import {
		getDocumentos,
    } from '@/helpers/api'
    
    import moment from 'moment'

	export default {
        name: 'Comentarios',
        props: {
            visible: {
                type: Boolean,
                default: () => false
            }
        },
        data(){
            return {
                error: null,
                loading: false,
                comments: [],
                comment: ''
            }
        },
        watch: {
            visible() {
                if (!this.visible) return
                this.getData()
            },
            comments() {
                this.scrollBottom()
            }
        },
        mounted() {
            if (this.visible) {
                this.getData()
            }
            this.$emit('created')
        },
        methods: {
            async getData() {

                this.loading = true

                setTimeout(() => {
                    
                    try {

                        //resp = await getDocumentos()
                        
                        this.comments = [{
                            text: 'Penatibus sagittis volutpat interdum dapibus mauris class eu, facilisi senectus ridiculus sociosqu sapien',
                            time: '31/4/2020',
                            user: 'Pedro'
                        },{
                            text: 'Vestibulum morbi aliquet phasellus et inceptos justo porttitor curae lacinia, netus fames aliquam pulvinar potenti ad fermentum ornare at',
                            time: '27/4/2020',
                            user: 'Carlos'
                        },{
                            text: 'Vulputate quis platea faucibus vel ante mauris nascetur vestibulum',
                            time: '12/4/2020',
                            user: 'Roberto'
                        },{
                            text: 'fermentum hac felis ullamcorper venenatis congue molestie erat magnis',
                            time: '09/5/2020',
                            user: 'Luis'
                        },{
                            text: 'Vulputate quis platea faucibus vel ante mauris nascetur vestibulum',
                            time: '10/5/2020',
                            user: 'Rodrigo'
                        }]

                    } catch(e) {
                        this.error = e
                    }

                    this.scrollBottom()

                    this.loading = false
                }, 500)
            },
            sendComment() {
                if(this.comment == '') return

                this.loading = true
                
                setTimeout(() => {
                    this.comments.push({
                        text: this.comment,
                        user: 'Juan',
                        time: moment().format('DD/MM/YYYY')
                    })
                    this.comment = ""

                    this.scrollBottom()

                    this.loading = false
                },300)
            },
            scrollBottom() {
                this.$nextTick(() => {
                    var container = document.getElementById('list-comment');
                    container.scrollTop = (parseInt(container.scrollHeight) + 200);
                })
            }
        }
	}
</script>

<style lang="scss">
.comentarios {
    overflow: hidden;
    height: 100%;
    ul.el-timeline {
        height: calc(100% - 94px);
        overflow-x: hidden;
        overflow-y: auto;
        margin-bottom: 5px;
        padding-right: 10px;
        padding-left: 5px;
    }
    textarea {
        min-height: 37px!important;
        max-height: 54px!important;
    }
}
</style>